__turbopack_context__.v({
  "categoryImage": "PrizeGroupingHeader-module__lTpR6W__categoryImage",
  "categoryInfo": "PrizeGroupingHeader-module__lTpR6W__categoryInfo",
  "categoryInfoButton": "PrizeGroupingHeader-module__lTpR6W__categoryInfoButton",
  "categoryInfoContainerOuter": "PrizeGroupingHeader-module__lTpR6W__categoryInfoContainerOuter",
  "categoryInfoContent": "PrizeGroupingHeader-module__lTpR6W__categoryInfoContent",
  "categoryInfoVisible": "PrizeGroupingHeader-module__lTpR6W__categoryInfoVisible",
  "categoryLink": "PrizeGroupingHeader-module__lTpR6W__categoryLink",
  "header": "PrizeGroupingHeader-module__lTpR6W__header",
  "subtitle": "PrizeGroupingHeader-module__lTpR6W__subtitle",
});
